require('../../../corporate-template/js/feature/center-spot.js');